var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#4AB3E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0978 20.8836C10.0978 18.5496 11.9871 16.6603 14.3211 16.6603H18.7666V14.4375H14.3211C10.7646 14.4375 7.875 17.3271 7.875 20.8836C7.875 24.44 10.7646 27.3296 14.3211 27.3296H18.7666V25.1069H14.3211C11.9871 25.1069 10.0978 23.2175 10.0978 20.8836Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.992 14.4375H24.5464V16.6603H28.992C31.3259 16.6603 33.2152 18.5496 33.2152 20.8836C33.2152 23.2175 31.3259 25.1069 28.992 25.1069H24.5464V27.3296H28.992C32.5484 27.3296 35.438 24.44 35.438 20.8836C35.438 17.3271 32.5484 14.4375 28.992 14.4375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8765 20.8834C13.8765 21.5502 14.321 21.9948 14.9879 21.9948H28.3246C28.9914 21.9948 29.4359 21.5502 29.4359 20.8834C29.4359 20.2165 28.9914 19.772 28.3246 19.772H14.9879C14.321 19.772 13.8765 20.2165 13.8765 20.8834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkColor);
export default __webpack_public_path__ + "static/media/link_color.6ce05ffa182262c716aa646fc9e3a1c8.svg";
export { ForwardRef as ReactComponent };